import React from 'react';
import NotificationsTable from './NotificationsTable';
import Modal from '../../../shared/modal';


interface INotificationsModal {
    openModal: boolean;
    handleCloseModal: () => void;
}

const NotificationsModal = ({
    openModal,
    handleCloseModal,
}: INotificationsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'}>
            <div className={'p-2 min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px] '}>
                <p className='mb-2 font-semibold text-sm dark:text-primary-darkMode'>Notifications</p>
                <div>
                    <NotificationsTable />
                </div>
            </div>
        </Modal >
    )
}
export default NotificationsModal;